module.exports = __webpack_public_path__ + "static/media/telefones.1edf3897.svg";